import {Directive, HostBinding, Input, OnInit} from '@angular/core';
import {filter, takeUntil} from 'rxjs/operators';
import {destroy$} from '../../components/destroyable';
import {Widget} from '../../components/layout/widget/widget';
import {WidgetCommonAction} from '../dashboard/layout/widget';

const REMOVABLE_CLASS = '-removable';

@Directive({
    selector: '[page-widget-removable]',
    standalone: false
})
export class PageWidgetRemovableDirective implements OnInit {

    @Input()
    public widget: Widget;

    public readonly destroy$ = destroy$();

    @HostBinding(`class.${REMOVABLE_CLASS}`)
    public isRemovable: boolean = true;

    public ngOnInit(): void {
        this.listenToWidgetActions();
    }

    private listenToWidgetActions(): void {
        this.widget.action$.pipe(
            takeUntil(this.destroy$),
            filter(action => action.type === WidgetCommonAction.REMOVE_WIDGET)
        ).subscribe(() => this.widget.destroy());
    }
}
